import React, { useEffect, useState } from 'react'
import "../styles/header.css"
import { Route, Routes, Link, useLocation } from "react-router-dom"

//import logo from "../images/logo.png"
import MenuIcon from '@mui/icons-material/Menu';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { IconButton, Tooltip } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PersonIcon from '@mui/icons-material/Person';
import { Circle, CircleOutlined } from '@mui/icons-material'
import {motion} from "framer-motion";
import ChatIcon from '@mui/icons-material/Chat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CloseIcon from '@mui/icons-material/Close';

export default function Header({userData,unread,allShopes,handleCurrentShope,currentShope}) {

  const [shope, setShope] =useState(currentShope);

  const handleChange = (event) => {
    setShope(event.target.value);
    handleCurrentShope(event.target.value)
    window.location.href = "/";
  };

  const matches = useMediaQuery('(max-width:700px)');


  let [flagUnreadMessage,handleFlagUnreadMessage]=useState([])

  useEffect(() => {
    let x = unread?.flagUnread?.filter(e => e > 0);
    handleFlagUnreadMessage(x);
  }, [unread.controlUnread, unread.flagUnread]);

 // console.log(unread.flagUnread, flagUnreadMessage); 
  let [menClick,handleMenuClick]=useState(false)  
  let location=useLocation()
  //console.log(location);
  useEffect(()=>{
    handleMenuClick(false)
  },[location.pathname])
  return (
   <div>
    <div className="header">
      <div className="header-left">
        <Link to="/"><img  className="header-logo" src={"/favicon.ico"} /></Link>
      </div>
      <div className="header-center">
        {!userData?.data?._id?
             <div  className="header-center-signIn"><Link style={{fontSize:"18px",color:"rgb(175, 111, 13)",textDecoration:"none"}} to="/signIn">Sign In</Link></div>
             :
            
             <>
               {matches?
                 <>
                   <div >{allShopes.length>0&&
                  <FormControl  size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-helper-label"  sx={{ color: 'rgb(175, 111, 13)' }}>Shope</InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={shope}
                      label="Shope"
                      onChange={handleChange}
                      defaultValue={currentShope}     
                      style={{color:"white"}} 
              
                    >
                      {allShopes?.map(e=>{
                          return  <MenuItem  value={e?._id}>{e?.shope_name}</MenuItem>

                      })}
                    </Select>
                  </FormControl>}</div>
                  <IconButton style={{background:"transparent",color:"rgb(175, 111, 13)"}} onClick={()=>handleMenuClick(!menClick)}><MenuIcon/></IconButton>
                 
                 </>
                 
                :
                <>
                <Link to="/cart"> 
                  <Tooltip title="Cart">
                      <IconButton><ShoppingCartIcon /></IconButton>
                  </Tooltip>
                  </Link>

                <Link className={`header-center-link ${flagUnreadMessage?.length>0&&"header-chat-link-unread"}`} to="/chat">
                          <>
                              {flagUnreadMessage?.length>0
                                ?
                            <Tooltip title="Chat">
                                <IconButton>
                                    <div> <ChatIcon style={{fontSize:"23px"}} /> </div>
                                      {flagUnreadMessage?.length>0&&<div className='header-center-link-circle'><Circle style={{fontSize:"11px",color:"red"}}/></div>}
                                </IconButton>
                             </Tooltip>
                                :
                            <Tooltip title="Chat">
                                <IconButton>
                                <ChatIcon style={{fontSize:"23px"}} /> 
                                </IconButton>
                            </Tooltip>
                              }
                          </>
                      
                  </Link>

                <Link to="/notifications">
                      <Tooltip title="Notifications">
                          <IconButton><NotificationsIcon  /></IconButton>
                      </Tooltip>
                  </Link>
                
                {allShopes.length>0&&
                  <FormControl  size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-helper-label" sx={{ color: 'rgb(175, 111, 13)' }}>Shope</InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={shope}
                      label="Shope"
                      onChange={handleChange}
                      defaultValue={currentShope}
                      style={{color:"white"}} 
                    >
                      {allShopes?.map(e=>{
                          return  <MenuItem  value={e?._id}>{e?.shope_name}</MenuItem>

                      })}
                    </Select>
                  </FormControl>}

                  <Link className="header-center-link" to="/profile">
                    <Tooltip title="Profile">
                          <IconButton><PersonIcon  /></IconButton>
                      </Tooltip>
                  </Link>
                </>
               }
             
             </>
        
        }
       
      </div>

    </div>
     { (menClick&&matches&&userData?.data?._id)&&
        <motion.div
         initial={{opacity:0,x:100}}
         animate={{opacity:1,x:0}}
         transition={{duration:0.4}}
          className="header-minimized">
                <div><IconButton onClick={()=>handleMenuClick(false)}><CloseIcon style={{color:"red"}}/></IconButton></div>
               
                <div>
                  <Link to="/cart"  className="header-center-link"> 
                    <ShoppingCartIcon style={{fontSize:"20px"}}/>

                    <div>Cart</div>
                  </Link>
                  
                </div>

                  <div>
                    <Link  className={`header-center-link ${flagUnreadMessage?.length>0&&"header-chat-link-unread"}`} to="/chat">
                   
                          <>
                              {flagUnreadMessage?.length>0
                                ?
                                  <>
                                      <div > 
                                         <ChatIcon style={{fontSize:"18px"}} /> </div>
                                        {flagUnreadMessage?.length>0&&<div className='header-center-link-circle'><Circle style={{fontSize:"11px",color:"red"}}/></div>}
                                  </>
                              
                                :
                                  <>
                                      <ChatIcon style={{fontSize:"18px"}} /> 
                                  </>
                              }
                          </>
                      
                      <div>Chat</div>
                    </Link></div>

                  <div><Link to="/notifications"  className="header-center-link">
                      <div><NotificationsIcon  style={{fontSize:"20px"}}/></div>
                      Notifications
                  </Link></div>

                  <div>
                     <Link className="header-center-link" to="/profile">
                      <div><PersonIcon style={{fontSize:"20px"}} /></div>
                       Profile
                     </Link>
                  </div>
      </motion.div>}
   </div>
  )
}
